import { useEffect, useState } from "react";
import { useParams } from "react-router-dom";
import { getCheckout } from "@api";
import { AdyenPaymentWooCommerceExpress } from "../../components/adyen/advanced/AdyenPaymentWooCommerceExpress";

const ExpressCheckout = () => {
  const { id } = useParams();
  const [checkout, setCheckout] = useState(null);
  const [error, setError] = useState(null);

  useEffect(() => {
    async function load() {
      try {
        const data = await getCheckout(id);
        if (!data || !data.id) {
          setError("Checkout not found or expired.");
          return;
        }
        setCheckout(data);
      } catch (err) {
        console.error("Failed to load checkout:", err);
        setError("Failed to load checkout.");
      }
    }
    load();
  }, [id]);

  if (error) {
    return (
      <div style={{ padding: 16, textAlign: "center", color: "#a00", fontSize: 14 }}>
        {error}
      </div>
    );
  }

  if (!checkout) {
    return (
      <div style={{ padding: 16, textAlign: "center", color: "#888", fontSize: 14 }}>
        Loading...
      </div>
    );
  }

  return (
    <div style={{ padding: 8 }}>
      <AdyenPaymentWooCommerceExpress checkout={checkout} />
    </div>
  );
};

export default ExpressCheckout;
